module.exports = __webpack_public_path__ + "img/7.d68727f6.webp";